export default __webpack_public_path__ + "static/media/arrow-down.f8e47110.svg";